<template>
  <div>
    <div class="platform-left"
         @click="showPlatform">
      <el-input :placeholder="$t('platform')"
                suffix-icon="el-icon-arrow-down"
                v-model="selectPlatform.platformName"
                readonly>
        <template slot="prefix"
                  v-if="selectPlatform.platformIcon">
          <img :src="selectPlatform.platformIcon"
               style="width: 25px;height: 25px;">
        </template>
      </el-input>
    </div>

    <el-dialog :title="$t('selectPlatform2')"
               center
               :visible.sync="showPlatformDialog"
               :width="isMobile ? '90%' : '40%'"
               :append-to-body="true"
               :modal-append-to-body="true"
               :lock-scroll="false"
               :show-close="false">
      <div class="popup-layout">
        <div class="popup-content">
          <div v-for="item in expertPlatformList"
               :key="item.platformName"
               class="platform-filter"
               :class="{ active: item.platformId == selectPlatform.platformId }"
               @click="handleChangeExpert(item)">
            <img :src="item.platformIcon"
                 style="margin-right: 5px;"
                 class="platform-filter-img">
            {{ item.platformName }}
          </div>
        </div>
      </div>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="showPlatformDialog = false">
          {{ $t('close') }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'SelectPurchasingPlatform',

  props: {
    expert: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isMobile: window.innerWidth < 768,
      showPlatformDialog: false,
      selectPlatform: {},
    }
  },

  computed: {
    expertPlatformList() {
      return this.expert?.expertPlatformList?.filter(item => item.enabled === 'Y') || []
    }
  },

  watch: {
    expert: {
      handler(newVal) {
        // 处理平台选择
        if (this.expertPlatformList?.length > 0) {

          const sele = JSON.parse(sessionStorage.getItem('selectPlatform')) || {}
          const isSave = this.expertPlatformList?.map(item => item.id).includes(sele.id)

          if (sele && isSave) {
            this.selectPlatform = sele
          } else {
            // 查找默认平台
            const defaultPlatform = this.expertPlatformList.find(item => item.defaulted === 'Y')
            // 如果没有默认平台，使用第一个平台
            this.selectPlatform = defaultPlatform || this.expertPlatformList[0]

            sessionStorage.setItem('selectPlatform', JSON.stringify(this.selectPlatform))
          }

          this.$emit('handleChangeExpert', this.selectPlatform)
        }
      },
      immediate: true
    }
  },

  methods: {
    //显示代购平台弹窗
    showPlatform() {
      this.showPlatformDialog = true
    },

    // 选择代购平台
    handleChangeExpert(item) {
      this.showPlatformDialog = false

      const defaultPlatform = this.expertPlatformList.find(e => e.platformId === item.platformId)
      // 如果没有默认平台，使用第一个平台
      this.selectPlatform = defaultPlatform

      sessionStorage.setItem('selectPlatform', JSON.stringify(this.selectPlatform))

      this.$emit('handleChangeExpert', this.selectPlatform)
    }
  },
}
</script>

<style scoped>
:deep .el-dialog--center .el-dialog__body {
  padding: 0 20px;
}

:deep .el-input__inner {
  height: 40px;
  font-size: 15px;
  border: 1px solid hsl(from var(--select-border-color) h s l / 0.8) !important;
  background-color: hsl(from var(--select-border-color) h s l / 0.5);
  border-radius: 12px;
}

.platform-left {
  margin-left: 10px;
}

/* 悬浮弹窗样式 */
.popup-layout {
  max-height: 300px;
  overflow-y: auto;
  /* 滚动条美化 */
  scrollbar-width: thin;
}

.popup-content {
  gap: 10px;
  padding: 15px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.platform-filter {
  padding: 10px 20px;
  border-radius: 10px;
  color: var(--link-color);
  cursor: pointer;
  font-size: 17px;
  transition: all 0.3s ease;
  flex-shrink: 0;
  white-space: nowrap;
  position: relative;
  z-index: 9998 !important;
  /* 确保分类过滤器不会裁剪下拉菜单 */
  overflow: visible !important;
  display: flex;
  align-items: center;
}

.platform-filter-img {
  width: 30px;
  height: 30px;
  border-radius: 8px;
}

.platform-filter.active {
  font-weight: bold;
  color: #fff;
  background: var(--primary-color);
}

@media (max-width: 480px) {
  .platform-filter {
    font-size: 15px;
    padding: 5px 10px;
  }

  .platform-filter-img {
    width: 22px;
    height: 22px;
  }

  .platform-left {
    margin-left: 0;
  }

  :deep .el-select {
    width: 100%;
  }

  :deep .el-input__inner {
    height: 40px;
    font-size: 15px;
  }

  :deep .el-input__icon {
    line-height: 40px;
  }

  :deep .el-input--prefix input {
    font-size: 16px;
  }
}

:deep .search-input input {
  border-radius: 4px 0 0 4px !important;
}

:deep .el-input__prefix {
  display: flex;
  align-items: center;
}

:deep .el-input--prefix input {
  padding-left: 35px !important;
}
</style>